import React from 'react'
import MetabaseDashBoardOne from '../../features/MetabaseDashBoard/MetabaseDashBoardOne'

const MetabaseDashBoard = () => {
  return (
    <div><MetabaseDashBoardOne/></div>
  )
}

export default MetabaseDashBoard